import { Container } from 'react-bootstrap';
import Fade from 'react-reveal/Fade';
import ExampleImg from '../../assets/example-images/example-placeholder.svg';

import example1 from '../../assets/example-images/example_1.png';
import example2 from '../../assets/example-images/example_2.png';
import example4 from '../../assets/example-images/example_4.png';
import example5 from '../../assets/example-images/example_5.png';
import example6 from '../../assets/example-images/example_6.png';
import example7 from '../../assets/example-images/example_7.png';
import example8 from '../../assets/example-images/example_8.png';


import { Section, Title } from '../../components/Common/PageElement';
import ExampleCard from './ExampleCard';
import React from "react";


const linkColor = '#1E66E5'

const Example = () => {
    return (
        <Section id="example">
            <Container className="example-container">
                <Fade top duration={1000} delay={600} distance="15px">
                    <Title>Examples</Title>
                </Fade>
                <Fade duration={300} delay={100} distance="30px">


                    {/*<div >*/}

                    {/*    <ExampleCard src={example1} title={"Flagellinolysins"} description={"Enzymatic flagellins as outlined in Eckhard et al., 2017."} link={"/app/#/?id=example_1"} />*/}
                    {/*    <p style={{fontSize:'14px'}}>*/}
                    {/*        Related Publication:*/}
                    {/*        <a href={"https://pubmed.ncbi.nlm.nih.gov/28900095/"}*/}
                    {/*           style={{color:linkColor,textDecoration:"underline"}}>*/}
                    {/*            Discovery of a proteolytic flagellin family in diverse bacterial phyla that*/}
                    {/*            assembles enzymatically active flagella</a>*/}
                    {/*    </p>*/}

                    {/*    <hr className="dashed"/>*/}
                    {/*</div>*/}

                    {/*<ExampleCard src={ExampleImg} title={"LCT Project"} description={"Adenylate isopentenyl transferase genes in bacteria."} link={"/app/#/?id=example_2"} />*/}

                    {/*<div >*/}

                    {/*    <ExampleCard src={example2} title={"IPT"} description={"IPT GFF files with custom matched PFAM."} link={"/app/#/?id=example_3"} />*/}
                    {/*    <hr className="dashed"/>*/}
                    {/*</div>*/}

                    <div>
                        <hr className="dashed"/>
                        <h4>Searching the GTDB database for a gene/protein of interest</h4>
                        <p style={{fontSize:'14px'}}>
                            This example shows the results of searching the McrA protein sequence against the archaeal database.
                        </p>
                        <p style={{fontSize:'14px'}}>
                            E-value=0.00001, coverage threshold=50%. Final hits were refined by choosing hits in the <span style={{'fontStyle':'italic'}}>Methanosarcina</span> genus.
                        </p>
                        <p style={{fontSize:'14px'}}>
                            Sequence used for search:&nbsp;
                            <a href={'https://www.uniprot.org/uniprotkb/P07962/entry#sequences'} rel="noopener noreferrer" target="_blank"
                               style={{ color: linkColor,textDecoration: 'underline'}}>
                                P07962 MCRA_METBF.
                            </a>

                        </p>
                        {/*<ExampleCard src={example4} title={"McrA"} description={"Search for gene neighborhoods of McrA (Methyl-coenzyme M reductase subunit alpha) homologs in the Methanosarcina genus."} link={"/app/#/?id=example_4"} />*/}
                        <ExampleCard src={example4} title={"McrA"} description={<p>Search for gene neighborhoods of McrA (Methyl-coenzyme M reductase subunit alpha) homologs in the <span style={{'fontStyle':'italic'}}>Methanosarcina</span> genus.</p>} link={"/app/#/?id=example_4"} />
                        <hr className="dashed"/>
                    </div>


                    <div>
                        <h4>Uploading a custom dataset of gene neighborhoods derived from the NCBI
                        </h4>
                        <p style={{fontSize:'14px'}}>
                            This example visualizes gene neighborhoods surrounding Slr4 (a type of S-layer protein discovered by &nbsp;
                            <a href={'https://onlinelibrary.wiley.com/doi/full/10.1111/mmi.14588'} rel="noopener noreferrer" target="_blank"
                               style={{ color: linkColor,textDecoration: 'underline'}}>
                                Ali et al., 2020
                            </a>) genes in <span style={{'fontStyle':'italic'}}>Gammaproteobacteria</span>.
                        </p>
                        <p style={{fontSize:'14px'}}>
                            Gene neighborhood information was extracted from the NCBI database as shown in&nbsp;
                            <a href={'https://github.com/satellite830/AnnoView'} rel="noopener noreferrer" target="_blank"
                               style={{ color: linkColor,textDecoration: 'underline'}}>
                                Github
                            </a>.
                        </p>
                        <ExampleCard src={example5} title={"Slr4"} description={"Visualize the gene neighborhoods of Slr4 and its homologs."} link={"/app/#/?id=example_5"} />
                        <hr className="dashed"/>
                    </div>


                    <div>
                        <h4>Visualization of larger sequences (contigs, plasmids, viral genomes, bacterial genomes)
                        </h4>

                        <p style={{fontSize:'14px'}}>
                            Although we do not currently support visualization of large (e.g., eukaryotic) genomes, AnnoView can be used to visualize smaller genomes or genomic regions.
                            The examples below show the use of AnnoView in exploring an alignment of betacoronavirus genomes, as well as the genome and plasmid of <span style={{'fontStyle':'italic'}}>Clostridium tetani</span>.
                        </p>

                        <ExampleCard src={example6} title={"Betacoronavirus"} description={"Visualize the gene neighborhoods of betacoronavirus genomes."} link={"/app/#/?id=example_6"} />
                        {/*<ExampleCard src={example7} title={"C. tetani contig"} description={"Visualization of a C. tetani contig reconstructed from ancient DNA."} link={"/app/#/?id=example_7"} />*/}


                        <ExampleCard src={example8} title={"Bacterial genome"} description={<p>Visualization of the entire <span style={{'fontStyle':'italic'}}>C. tetani</span> genome.</p>} link={"/app/#/?id=example_8"} />
                        <hr className="dashed"/>
                    </div>




                </Fade>
            </Container>
        </Section>
    )
}

export default Example